module.exports = __webpack_public_path__ + "img/refresh.69f1b294.png";